<div class="nav-tab">
  <ul class="nav_tab-list">
    @for (item of lienItems; track item) {
      <li class="nav_tab-elem" routerLinkActive="is-active">
        <a [routerLink]="item.routerLink" href="" >{{item.libelle}}</a>
      </li>
    }
  </ul>
</div>
